// ** Type import
import type { HorizontalNavItemsType } from '@erikdakoda/site-template-ui/types';
import type { VerticalNavItemsType } from '@erikdakoda/site-template-ui/types';

const navItems: HorizontalNavItemsType = [
  {
    title: 'Benefits',
    path: '/',
    icon: 'hand-holding-seedling',
    roles: ['USER', 'ADMIN', 'TEAM'],
  },
  {
    title: 'Pricing',
    path: '/user/pricing',
    icon: 'money-bill-wave',
    roles: ['USER', 'ADMIN', 'TEAM'],
  },
  {
    title: 'FAQ',
    path: '/user/faq',
    icon: 'life-ring',
    roles: ['USER', 'ADMIN', 'TEAM'],
  },
];

export const HorizontalLandingNavItems = () => navItems as HorizontalNavItemsType;

export const VerticalLandingNavItems = () => navItems as VerticalNavItemsType;
